import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { EditorialMarquee } from "@/components/landing/Marquee";
import { Benefits } from "@/components/landing/Benefits";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Ingredients } from "@/components/landing/Ingredients";
import { UgcVideos } from "@/components/landing/UgcVideos";
import { Reviews } from "@/components/landing/Reviews";
import { Subscription } from "@/components/landing/Subscription";
import { FinalCta } from "@/components/landing/FinalCta";
import { Faq } from "@/components/landing/Faq";
import { Footer } from "@/components/landing/Footer";

export default function Landing() {
  const [content, setContent] = useState({ reviews: [], videos: [], results: [] });

  useEffect(() => {
    api.get("/content").then(({ data }) => setContent(data)).catch(() => {});
  }, []);

  return (
    <main data-testid="landing-page">
      <Nav />
      <Hero />
      <EditorialMarquee />
      <Benefits />
      <HowItWorks />
      <Ingredients />
      <UgcVideos videos={content.videos} />
      <Reviews reviews={content.reviews} />
      <Subscription />
      <FinalCta />
      <Faq />
      <Footer />
    </main>
  );
}
